import React, { Component } from 'react';
import Services, { Service } from '../common/Services';
import Section from '../common/Section';

export default class IhrBad extends Component {
  componentDidMount() {
    try {
      window.galleryIhrBad();
      window.adjustSubmenu();
    }
    catch (err) {
      console.log(err);
    }
  }

  render() {
    return (
      <div className="IhrBad">
        <div id="Planung u. Angebot" className="block row" data-nested="not-nested" data-containerid="" data-containercssclass="">
            <div className="col col-md-12">
              <respond-html id="html-1" description="HTML"><a name="unser-service"></a>
                <div className="section">
                  <div className="services">
                    <div className="row">
                      <div className="col-lg-12 text-center">
                        <h1 className="section-heading">Planung Ihres Bades</h1>
                        <p>Sie interessieren sich für eine neues Bad? In 3 Schritten zu Ihrer individuellen Planung:</p>
                      </div>
                    </div>
                    <div className="row text-center">
                      <div className="col-md-4">
                        <span className="fa-stack fa-3x">
                          <i className="fa fa-circle fa-stack-2x text-primary"></i>
                          <i className="fa fa-file-signature fa-5 fa-stack-1x fa-inverse"></i>
                        </span>
                        <h4 className="service-heading">1. DATENAUFNAHME</h4>
                        <p className="text-muted">Wir möchten Sie gerne umfassend fachlich beraten und benötigen noch weitere Details. Beantworten Sie hierzu unverbindlich unsere Fragen zu Ihrer aktuellen Situation und Ihren Anforderungen. 
                          Unser Formular finden Sie über den folgenden <a href="https://form.jotform.com/241883854372365" target="blank">Link Anfrage Badsanierung (externe Webseite)</a><i className="fa-solid fa-up-right-from-square"></i>: 
                          <p></p>
                          <a href="https://form.jotform.com/241883854372365" target="blank">
                            <button type="button" class="btn btn-primary btn-sm">Zum Formular Anfrage Badsanierung</button>
                          </a>
                          <p></p>
                          </p>
                      </div>
                      <div className="col-md-4">
                        <span className="fa-stack fa-3x">
                          <i className="fa fa-circle fa-stack-2x text-primary"></i>
                          <i className="fa fa-search fa-5 fa-stack-1x fa-inverse"></i>
                        </span>
                        <h4 className="service-heading">2. PRÜFUNG IHRER DATEN</h4>
                        <p className="text-muted">Wie geht es für Sie weiter? Nun sind wir dran! Im nächsten Schritt prüfen wir Ihre Daten. Aufgrund der aktuell hohen Nachfrage kommt es vereinzelt zu längeren Bearbeitungszeiten.</p>
                      </div>
                      <div className="col-md-4">
                        <span className="fa-stack fa-3x">
                          <i className="fa fa-circle fa-stack-2x text-primary"></i>
                          <i className="fa fa-calendar fa-5 fa-stack-1x fa-inverse"></i>
                        </span>
                        <h4 className="service-heading">3. Termin und Beratung</h4>
                        <p className="text-muted">Nach der Prüfung wird die Planung konkreter. Wir klären weitere Details telefonisch und sprechen mit Ihnen über ein grobes Budget für Ihr Projekt. Anschließend sprechen wir über konkrete Ideen zur Umsetzung.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </respond-html>
            </div>
          </div>
        <Section id="Unser Service">
          <Services heading="IHR BAD UNSER ANSPRUCH">
            <Service
              icon="fa-thumbs-up"
              heading="Aus einer Hand"
              description="Wir bieten Ihnen eine Komplettbadsanierung aus einer Hand. Sie haben einen Ansprechpartner für alle Fragen. Wir koordinieren alle Gewerke über Elektriker, Fliesenleger und Raumausstatter. So können Sie sich entspannt auf Ihr neues Bad freuen."
            />
            <Service
              icon="fa-pencil"
              heading="Individuelle Planung"
              description="Wir besprechen mit Ihnen genau, wie Ihr neues Wohlfühlbad aussehen soll und erstellen eine individuelle Farb- Handskizze Ihres Bades. Umfassende Beratung über alle Bereiche hinweg. Badausstattung, Fliesenauswahl, Decken- und Wandgestaltung ist für uns selbstverständlich."
            />
            <Service
              icon="fa-wrench"
              heading="Staubfreie Sanierung"
              description="Mittels Einsatz einer speziellen Staubschutztür können wir Ihnen eine nahezu staubfreie Badsanierung ermöglichen. Besonders bei einer Sanierung im bewohnten Bereich ist dies besonders wichtig. Wir beraten Sie gerne."
            />
          </Services>
        </Section>
        <div id="content" className="container" role="main">
        <div id="gallery" className="block row" data-nested="not-nested" data-containerid="" data-containercssclass="">
            <div className="col col-md-12">
              <div id="Kundenreferenzen" className="section bg-light-gray">
                <div className="row">
                  <div className="col-md-3">
                    <h3>Traumbäder designed by Firma Pailer</h3>
                    <p className="text-muted">Lassen Sie sich von unseren neuesten Traumbäder inspirieren - in Szene gesetzt von <a href="https://www.instagram.com/krughendrik/" target="_blank">Hendrik Krug</a>.</p>
                  </div>
                  <div className="col-md-9">
                    <div id="highlight-baeder-gallery" className="gallery" style={{ display: 'none' }}>
                      <img src="/files/ihr-bad/highlight-gallery/thumbnail/01.JPG" data-image="/files/ihr-bad/highlight-gallery/01.JPG" />
                      <img src="/files/ihr-bad/highlight-gallery/thumbnail/02.JPG" data-image="/files/ihr-bad/highlight-gallery/02.JPG" />
                      <img src="/files/ihr-bad/highlight-gallery/thumbnail/03.JPG" data-image="/files/ihr-bad/highlight-gallery/03.JPG" />
                      <img src="/files/ihr-bad/highlight-gallery/thumbnail/04.JPG" data-image="/files/ihr-bad/highlight-gallery/04.JPG" />
                      <img src="/files/ihr-bad/highlight-gallery/thumbnail/06.JPG" data-image="/files/ihr-bad/highlight-gallery/06.JPG" />
                      <img src="/files/ihr-bad/highlight-gallery/thumbnail/07.JPG" data-image="/files/ihr-bad/highlight-gallery/07.JPG" />
                      <img src="/files/ihr-bad/highlight-gallery/thumbnail/08.JPG" data-image="/files/ihr-bad/highlight-gallery/08.JPG" />
                      <img src="/files/ihr-bad/highlight-gallery/thumbnail/09.JPG" data-image="/files/ihr-bad/highlight-gallery/09.JPG" />
                      <img src="/files/ihr-bad/highlight-gallery/thumbnail/10.JPG" data-image="/files/ihr-bad/highlight-gallery/10.JPG" />
                      <img src="/files/ihr-bad/highlight-gallery/thumbnail/11.JPG" data-image="/files/ihr-bad/highlight-gallery/11.JPG" />
                      <img src="/files/ihr-bad/highlight-gallery/thumbnail/12.JPG" data-image="/files/ihr-bad/highlight-gallery/12.JPG" />
                      <img src="/files/ihr-bad/highlight-gallery/thumbnail/13.JPG" data-image="/files/ihr-bad/highlight-gallery/13.JPG" />
                      <img src="/files/ihr-bad/highlight-gallery/thumbnail/14.JPG" data-image="/files/ihr-bad/highlight-gallery/14.JPG" />
                      <img src="/files/ihr-bad/highlight-gallery/thumbnail/15.JPG" data-image="/files/ihr-bad/highlight-gallery/15.JPG" />
                      <img src="/files/ihr-bad/highlight-gallery/thumbnail/16.JPG" data-image="/files/ihr-bad/highlight-gallery/16.JPG" />
                      <img src="/files/ihr-bad/highlight-gallery/thumbnail/17.JPG" data-image="/files/ihr-bad/highlight-gallery/17.JPG" />
                      <img src="/files/ihr-bad/highlight-gallery/thumbnail/18.JPG" data-image="/files/ihr-bad/highlight-gallery/18.JPG" />
                      <img src="/files/ihr-bad/highlight-gallery/thumbnail/19.JPG" data-image="/files/ihr-bad/highlight-gallery/19.JPG" />
                      <img src="/files/ihr-bad/highlight-gallery/thumbnail/20.JPG" data-image="/files/ihr-bad/highlight-gallery/20.JPG" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="gallery" className="block row" data-nested="not-nested" data-containerid="" data-containercssclass="">
            <div className="col col-md-12">
              <div id="Kundenreferenzen" className="section">
                <div className="row">
                  <div className="col-md-3">
                    <h3>Unsere Kundenreferenzen</h3>
                    <p className="text-muted">Wir lassen Ihren Traum von einem neuen Bad wahr werden. Schauen Sie sich doch mal die Bäder unserer
                                zufriedenen Kunden an. Lassen Sie sich davon inspirieren! Vielleicht können wir hier schon
                                bald Ihr Bad präsentieren.</p>
                  </div>
                  <div className="col-md-9">
                    <div id="baeder-gallery" className="gallery" style={{ display: 'none' }}>
                      <img src="/files/ihr-bad/gallery/thumbnail/01.JPG" data-image="/files/ihr-bad/gallery/01.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/02.JPG" data-image="/files/ihr-bad/gallery/02.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/03.JPG" data-image="/files/ihr-bad/gallery/03.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/04.JPG" data-image="/files/ihr-bad/gallery/04.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/05.JPG" data-image="/files/ihr-bad/gallery/05.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/06.JPG" data-image="/files/ihr-bad/gallery/06.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/07.JPG" data-image="/files/ihr-bad/gallery/07.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/08.JPG" data-image="/files/ihr-bad/gallery/08.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/09.JPG" data-image="/files/ihr-bad/gallery/09.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/10.JPG" data-image="/files/ihr-bad/gallery/10.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/11.JPG" data-image="/files/ihr-bad/gallery/11.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/12.JPG" data-image="/files/ihr-bad/gallery/12.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/13.JPG" data-image="/files/ihr-bad/gallery/13.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/14.JPG" data-image="/files/ihr-bad/gallery/14.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/15.JPG" data-image="/files/ihr-bad/gallery/15.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/16.JPG" data-image="/files/ihr-bad/gallery/16.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/17.JPG" data-image="/files/ihr-bad/gallery/17.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/18.JPG" data-image="/files/ihr-bad/gallery/18.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/19.JPG" data-image="/files/ihr-bad/gallery/19.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/20.JPG" data-image="/files/ihr-bad/gallery/20.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/21.JPG" data-image="/files/ihr-bad/gallery/21.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/22.JPG" data-image="/files/ihr-bad/gallery/22.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/23.JPG" data-image="/files/ihr-bad/gallery/23.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/24.JPG" data-image="/files/ihr-bad/gallery/24.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/25.JPG" data-image="/files/ihr-bad/gallery/25.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/26.JPG" data-image="/files/ihr-bad/gallery/26.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/27.JPG" data-image="/files/ihr-bad/gallery/27.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/28.JPG" data-image="/files/ihr-bad/gallery/28.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/29.JPG" data-image="/files/ihr-bad/gallery/29.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/30.JPG" data-image="/files/ihr-bad/gallery/30.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/31.JPG" data-image="/files/ihr-bad/gallery/31.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/32.JPG" data-image="/files/ihr-bad/gallery/32.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/33.JPG" data-image="/files/ihr-bad/gallery/33.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/34.JPG" data-image="/files/ihr-bad/gallery/34.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/35.JPG" data-image="/files/ihr-bad/gallery/35.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/36.JPG" data-image="/files/ihr-bad/gallery/36.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/37.JPG" data-image="/files/ihr-bad/gallery/37.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/38.JPG" data-image="/files/ihr-bad/gallery/38.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/39.JPG" data-image="/files/ihr-bad/gallery/39.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/40.JPG" data-image="/files/ihr-bad/gallery/40.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/41.JPG" data-image="/files/ihr-bad/gallery/41.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/42.JPG" data-image="/files/ihr-bad/gallery/42.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/43.JPG" data-image="/files/ihr-bad/gallery/43.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/44.JPG" data-image="/files/ihr-bad/gallery/44.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/45.JPG" data-image="/files/ihr-bad/gallery/45.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/46.JPG" data-image="/files/ihr-bad/gallery/46.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/47.JPG" data-image="/files/ihr-bad/gallery/47.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/48.JPG" data-image="/files/ihr-bad/gallery/48.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/49.JPG" data-image="/files/ihr-bad/gallery/49.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/50.JPG" data-image="/files/ihr-bad/gallery/50.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/51.JPG" data-image="/files/ihr-bad/gallery/51.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/52.JPG" data-image="/files/ihr-bad/gallery/52.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/53.JPG" data-image="/files/ihr-bad/gallery/53.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/54.JPG" data-image="/files/ihr-bad/gallery/54.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/55.JPG" data-image="/files/ihr-bad/gallery/55.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/56.JPG" data-image="/files/ihr-bad/gallery/56.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/57.JPG" data-image="/files/ihr-bad/gallery/57.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/58.JPG" data-image="/files/ihr-bad/gallery/58.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/59.JPG" data-image="/files/ihr-bad/gallery/59.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/60.JPG" data-image="/files/ihr-bad/gallery/60.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/61.JPG" data-image="/files/ihr-bad/gallery/61.JPG" />
                      <img src="/files/ihr-bad/gallery/thumbnail/62.JPG" data-image="/files/ihr-bad/gallery/62.JPG" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="Themen portfolio" className="block row" data-nested="not-nested" data-containerid="" data-containercssclass="">
            <div className="col col-md-12">
              <div id="Dusch Wc" className="section bg-light-gray portfolio">
                <div className="row">
                  <div className="col-md-3 col-sm-6 portfolio-item">
                    <a href="ihr-bad/info#dusch-wc" className="portfolio-link" data-toggle="modal">
                      <div className="portfolio-hover">
                        <div className="portfolio-hover-content">
                          <i className="fa fa-plus fa-3x"></i>
                        </div>
                      </div>
                      <img src="/files/ihr-bad/portfolio/dusch-wc/banner.jpg" className="img-responsive" alt="" />
                    </a>
                    <a href="ihr-bad/info#dusch-wc">
                      <div className="portfolio-caption">
                        <h4>Dusch- WC, die sanfte Reinigung mit Wasser</h4>
                        <p className="text-muted">Wasser bewährt sich bei der Körperhygiene am besten. Unseren intimsten Bereich des Körpers,
                                        an dem Sauberkeit höchste Priorität haben sollte, reinigen wir jedoch nach wie vor
                                        mit Papier. Informieren Sie sich hier umfassend über die neue sanfte Reinigung mit
                                        Wasser durch ein Dusch- WC.</p>
                      </div>
                    </a>
                  </div>
                  <div className="col-md-3 col-sm-6 portfolio-item">
                    <a href="ihr-bad/info#barrierefrei" className="portfolio-link" data-toggle="modal">
                      <div className="portfolio-hover">
                        <div className="portfolio-hover-content">
                          <i className="fa fa-plus fa-3x"></i>
                        </div>
                      </div>
                      <img src="/files/ihr-bad/portfolio/barrierefreie-baeder/banner.jpg" className="img-responsive" alt="" />
                    </a>
                    <a href="ihr-bad/info#barrierefrei">
                      <div className="portfolio-caption">
                        <h4>Barrierefreie Bäder</h4>
                        <p className="text-muted">Komfort und Sicherheit im Alter spielen auch im Bad eine wichtige Rolle. Wir zeigen Ihnen
                                        welche Möglichkeiten Sie haben bei einer Modernisierung Ihres Bades. Design und Funktion
                                        gehen hier Hand in Hand.</p>
                      </div>
                    </a>
                  </div>
                  <div className="col-md-3 col-sm-6 portfolio-item">
                    <a href="ihr-bad/info#highlights" className="portfolio-link" data-toggle="modal">
                      <div className="portfolio-hover">
                        <div className="portfolio-hover-content">
                          <i className="fa fa-plus fa-3x"></i>
                        </div>
                      </div>
                      <img src="/files/ihr-bad/portfolio/highlights-im-bad/banner.jpg" className="img-responsive" alt="" />
                    </a>
                    <a href="ihr-bad/info#highlights">
                      <div className="portfolio-caption">
                        <h4>Highlights im Bad</h4>
                        <p className="text-muted">Längst ist das Bad keine reine Nasszelle mehr. Sehen Sie selbst welche vielfältigen Gestaltungsmöglichkeiten
                                        sich Ihnen bieten. Technischen Raffinessen machen Ihr Bad zu etwas Besonderem.</p>
                      </div>
                    </a>
                  </div>
                  <div className="col-md-3 col-sm-6 portfolio-item">
                    <a href="ihr-bad/info#freihandskizze" className="portfolio-link" data-toggle="modal">
                      <div className="portfolio-hover">
                        <div className="portfolio-hover-content">
                          <i className="fa fa-plus fa-3x"></i>
                        </div>
                      </div>
                      <img src="/files/ihr-bad/portfolio/freihandskizze/banner.jpg" className="img-responsive" alt="" />
                    </a>
                    <a href="ihr-bad/info#freihandskizze">
                      <div className="portfolio-caption">
                        <h4>Persönliche Freihandskizze</h4>
                        <p className="text-muted">Machen Sie sich vorab ein Bild Ihres neuen Bades. Wir machen es möglich, mit einer persönlichen
                                        Freihandskizze von Kurt Pailer. Schauen Sie sich doch einmal in unserer Galerie um.</p>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="Hersteller banner" className="block row" data-nested="not-nested" data-containerid="" data-containercssclass="">
            <div className="col col-md-12">
              <div className="hersteller-section">
                <div className="row">
                  <div className="col-md-12 text-center">
                    
                      <img className="hersteller" src="/files/ihr-bad/hersteller/geberit_logo.png" />
                      <img className="hersteller" src="/files/ihr-bad/hersteller/Grohe-logo.png" />
                      <img className="hersteller" src="/files/ihr-bad/hersteller/hansa-logo.png" />
                      <img className="hersteller" src="/files/ihr-bad/hersteller/hansgrohe-logo.png" />
                      <img className="hersteller" src="/files/ihr-bad/hersteller/Keuco-Logo.png" />
                      <img className="hersteller" src="/files/ihr-bad/hersteller/laufen-logo.png" />
                      <img className="hersteller" src="/files/ihr-bad/hersteller/Roca-logo.png" />
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="Dusch-WC" className="block row" data-nested="not-nested" data-containerid="" data-containercssclass="">
            <div className="col col-md-12">
              <div className="section bg-light-gray">
                <div className="row">
                  <div className="col-md-12">
                    <div className="text-center">
                      <h1>DUSCH- WC, DIE SANFTE REINIGUNG MIT WASSER</h1>
                      <hr className="yellow"></hr>
                    </div>
                  </div>
                </div>
                <div className="row same-height-box">
                  <div className="col-md-6 same-height shadowbox-white shadow-border-black-top">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="text-center">
                          <h4>AQUA CLEAN DUSCH-WC</h4>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="text-center">
                          <p>Wasser bewährt sich bei der Körperhygiene am besten. Unseren intimsten Bereich des
                                            Körpers, an dem Sauberkeit höchste Priorität haben sollte, reinigen wir jedoch
                                            nach wie vor mit Papier. Informieren Sie sich hier umfassend über die neue sanfte
                                            Reinigung mit Wasser durch ein Dusch- WC.</p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div align="center" className="embed-responsive embed-responsive-16by9">
                          <video controls="" className="embed-responsive-item">
                            <source src="/files/ihr-bad/portfolio/dusch-wc/mera.mp4" type="video/mp4" />
                          </video>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="same-height shadowbox-gray shadow-border-top">
                      <h4>Sanfte Reinigung</h4>
                      <ul>
                        <li>Reinigung des Analbereiches mit angenehm temperiertem Wasser</li>
                        <li>die Position der Reinigungsdüse sowie die Strahlstärke kann dabei individuell eingestellt
                                        werden
                                    </li>
                        <li>automatische Reinigung der Wasserdüse nach jeder Benutzung</li>
                        <li>integrierte Oszillationsfunktion, die Düse bewegt sich automatisch vor und zurück</li>
                      </ul>
                      <h4>Trocknung</h4>
                      <ul>
                        <li>schonende Trocknung mit einstellbarer Temperatur mittels eingebautem Warmluftföhn</li>
                      </ul>
                      <h4>Ladydusche</h4>
                      <ul>
                        <li>sanfte Reinigung des Intimbereiches der Frau, durch eine spezielle Düsenanordnung und
                                        individuell einstellbarer Strahlstärke</li>
                      </ul>
                      <h4>Beheizbarer Sitz</h4>
                      <ul>
                        <li>eine eingebaute Sitzheizung fördert das Wohlbefinden und sorgt für einen angenehmen Sitzkomfort</li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="same-height shadowbox-white shadow-border-top">
                      <h4>Fernbedienung</h4>
                      <ul>
                        <li>alle Funktion können über eine Fernbedienung bequem und komfortabel gesteuert werden</li>
                      </ul>
                      <h4>Energiesparfunktion</h4>
                      <ul>
                        <li>eine Energiesparfunktion kann eingestellt werden. Dabei werden die elektrischen Funktionen
                                        erst bei Bedarf aktiviert</li>
                      </ul>
                      <h4>Sitzerkennung</h4>
                      <ul>
                        <li>mittels Sensor wird gewährleistet, dass alle Funktionen nur bei Benutzung ausgelöst werden
                                        können
                                    </li>
                      </ul>
                      <h4>Geruchsfilter</h4>
                      <ul>
                        <li>unangenehme Gerüche werden mittels Gebläse mit Aktivkohlefilter entfernt</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="Barrierefrei" className="block row" data-nested="not-nested" data-containerid="" data-containercssclass="">
            <div className="col col-md-12">
              <respond-html id="html-5" description="HTML">
                <a name="barrierefrei"></a>
                <div className="barrierefrei-jumbo">
                  <div className="section">
                    <div className="head-section text-center">
                      <h1>
                        <span>Barrierefreie </span>
                        <span>Bäder
                                    <span></span>
                        </span>
                      </h1>
                    </div>
                    <div className="body-section row same-height-box text-center">
                      <div className="col col-md-4 same-height">
                        <h1>
                          <span>Bodenebene </span>
                          <span className="yellow">Dusche</span>
                        </h1>
                      </div>
                      <div className="col col-md-4 same-height">
                        <h1>
                          <span>Unterfahrbarer </span>
                          <span className="yellow">Waschtisch</span>
                        </h1>
                      </div>
                      <div className="col col-md-4 same-height">
                        <h1>
                          <span>Verstellbare </span>
                          <span className="yellow">Spiegel</span>
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="barrierefrei-banner section bg-light-gray">
                  <div className="row same-height-box">
                    <div className="col-md-6 text-center same-height info">
                      <div>
                        <p>
                          <i className="fa fa-info fa-5x"></i>
                        </p>
                        <span className="text-biggest">
                          Komfort und Sicherheit im Alter spielen auch im Bad eine wichtige Rolle. Wir zeigen Ihnen welche Möglichkeiten Sie haben
                                    bei einer Modernisierung Ihres Bades. Design und Funktion gehen hier Hand in Hand.
                                </span>
                      </div>
                    </div>
                    <div className="col-md-6 text-center same-height info">
                      <div>
                        <p>
                          <i className="fa fa-eur fa-5x"></i>
                        </p>
                        <span className="text-biggest">Modernisierungsmaßnahmen werden auch von der KFW Bank gefördert, auch hierzu können wir Sie
                                    gerne beraten.
                                </span>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 text-center">
                      <a href="http://www.keuco.de/" target="blank">
                        <img className="hersteller" src="/files/ihr-bad/hersteller/Keuco-Logo.png" />
                      </a>
                      <a href="https://www.hewi.com" target="blank">
                        <img className="hersteller" src="/files/ihr-bad/hersteller/hewi.png" />
                      </a>
                      <a href="https://www.kfw.de/" target="blank">
                        <img className="hersteller" src="/files/ihr-bad/hersteller/kfw.png" />
                      </a>
                      <a href="http://www.aktion-barrierefreies-bad.de/" target="blank">
                        <img className="hersteller" src="/files/ihr-bad/hersteller/aktion-barrierefreies-bad-logo.png" />
                      </a>
                    </div>
                  </div>
                </div>
              </respond-html>
            </div>
            <div className="col col-md-4 same-height"></div>
          </div>
          <div id="Highlights" className="block row" data-nested="not-nested" data-containerid="" data-containercssclass="">
            <div className="col col-md-12">
              <respond-html id="html-6" description="HTML">
                <a name="highlights"></a>
                <div className="section">
                  <div className="row">
                    <div className="col-md-12 text-center">
                      <h1>Highlights im Bad</h1>
                      <hr className="white"></hr>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="shadowbox-gray shadow-border-top">
                        <div className="row">
                          <div className="col-md-12">
                            <h2>Automatische Badewannenbefüllung</h2>
                            <div>Mit der Multiplex Trio F hat
                                            <a href="http://www.viega.de/multiplex-trio-e-elektronisch-gesteuerte-badewannen-garnitur-mit-zulauf-ablauf-und-ueberlauf-9683.html#"
                                target="blank">Viega</a> die erste „geräuschlose“ Wannenbefüllung entwickelt. Noch komfortabler
                              wird diese jetzt durch einen motorbetriebenen Ventilkegel in Kombination mit
                              der Multiplex Trio E: Durch Knopfdruck lassen sich Ablauf sowie Öffnen und Schließen
                              des Ventilkegels steuern. Die Wassertemperatur lässt sich genauso einfach voreinstellen
                                            und der Zulauf stoppt automatisch, wenn die ausgewählte Füllmenge erreicht ist.</div>
                            <h3>Ihre Vorteile auf einen Blick:</h3>
                            <ul>
                              <li>Individuelle Voreinstellungen (Füllmenge und/oder Höchsttemperatur) für mehrere
                                                Nutzer mittels Memory-Funktion</li>
                              <li>Verbrühschutz</li>
                              <li>Reinigungsmodus mit "Tastensperre"</li>
                              <li>freie Platzierung der Bedien- und Displayelemente am Wannenrand, auf einem Podest
                                                oder an der Wand</li>
                              <li>Einbausets für die Platzierung außerhalb des Wannenrandes optional erhältlich</li>
                            </ul>
                            <h3>Multiplex Trio E App – Bedienkomfort zum Mitnehmen</h3>
                            <div>Mit der neuen
                                            <a href="http://www.viega.de/multiplex-trio-e-elektronisch-gesteuerte-badewannen-garnitur-mit-zulauf-ablauf-und-ueberlauf-9683.html#"
                                target="blank">Viega</a> Multiplex Trio E-App lässt sich das individuelle Badevergnügen zukünftig
                              aus der ganzen Wohnung steuern. Etwa ganz bequem von der Wohnzimmercouch aus
                              – natürlich nach individueller Einstellung. Wird die App geschlossen, ist die
                              Armatur wieder manuell bedienbar. Natürlich wurde auch an Schutzmechanismen gedacht.
                              So schaltet sich die Multiplex Trio E-Armatur beispielsweise ab, falls die Funkverbindung
                                            zum Smartphone oder Tablet einmal unterbrochen wird. Eine sichere Sache.</div>
                          </div>
                        </div>
                        <div className="row">
                          <br></br>
                          <div className="col-md-12">
                            <div id="viega-gallery" className="gallery" style={{ display: 'none' }}>
                              <img src="/files/ihr-bad/highlights/viega/thumbnail/01.jpg" data-image="/files/ihr-bad/highlights/viega/01.jpg" />
                              <img src="/files/ihr-bad/highlights/viega/thumbnail/02.jpg" data-image="/files/ihr-bad/highlights/viega/02.jpg" />
                              <img src="/files/ihr-bad/highlights/viega/thumbnail/03.jpg" data-image="/files/ihr-bad/highlights/viega/03.jpg" />
                              <img src="/files/ihr-bad/highlights/viega/thumbnail/04.jpg" data-image="/files/ihr-bad/highlights/viega/04.jpg" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="shadowbox-white shadow-border-black-top">
                        <div className="row">
                          <div className="col-md-12">
                            <h2>Geberit Monolith Sanitärmodule</h2>
                            <div>Eine Klasse für sich. Badgestaltung mit der Monolith Designfamilie. Geberit Monolith
                                          definiert die Schnittstelle zwischen Sanitärgegenständen und der Versorgungs-
                                          und Entwässerungsinstallation neu. Die Sanitärmodule für WC, Waschtisch und Bidet
                                          verbinden zeitgemäßes Baddesign mit einer schnellen und einfachen Installation,
                                            die nahezu ohne Eingriffe in die vorhandene Bausubstanz möglich ist.</div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <br></br>
                            <div id="geberit-monolith-gallery" className="gallery" style={{ display: 'none' }}>
                              <img src="/files/ihr-bad/highlights/monolith/thumbnail/01.jpg" data-image="/files/ihr-bad/highlights/monolith/01.jpg" />
                              <img src="/files/ihr-bad/highlights/monolith/thumbnail/02.jpg" data-image="/files/ihr-bad/highlights/monolith/02.jpg" />
                              <img src="/files/ihr-bad/highlights/monolith/thumbnail/03.jpg" data-image="/files/ihr-bad/highlights/monolith/03.jpg" />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <h3>Sortimentserweiterung Geberit Monolith Sanitärmodule</h3>
                            <div>Neu zur Familie der Geberit Monolith Sanitärmodule für WC ist der Geberit Monolith
                                        Plus dazu gestoßen. Zusätzliche Komfortfunktionen wie Geruchsabsaugung direkt
                                        aus der WC-Keramik, das dezente Orientierungslicht und die Soft-Touch-Tasten
                                            für die Spülauslösung begeistern jeden zukünftigen Anwender.</div>
                            <h3>Die Produkt-Idee</h3>
                            <div>Wenn bei Neubau oder Renovation aus Zeit- oder Kostengründen auf eine raumgestaltende
                                        Vorwandinstallation verzichtet werden soll, ist die Wahl eines Aufputzspülkastens
                                        immer noch die Regel. Das Sanitärmodul Geberit Monolith bietet ab sofort eine
                                        ästhetische und stilvolle Alternative, die auch im neuen Bad architektonische
                                            Akzente setzt.</div>
                            <h3>Die elegante Alternative</h3>
                            <div>Der Geberit Monolith ist ein Sanitärmodul, das die komplette Sanitärtechnik raffiniert
                                        hinter einer fertigen Oberfläche aus hochwertigen Materialien wie Glas und gebürstetem
                                        Aluminium versteckt. Seine klaren Formen und die eingesetzten Materialien setzen
                                            den Geberit Monolith als architektonisches Gestaltungselement in Szene.</div>
                            <h3>Schnelle und einfache Installation</h3>
                            <div>Der Geberit Monolith lässt sich ohne bauliche Anpassungen und Eingriffe in die Bausubstanz
                                        an bestehende Wasser- und Abwasseranschlüsse anschließen. Das Herzstück ist ein
                                        Geberit Spülkasten für die saubere Ausspülung der WC-Keramik. Die Montage erfolgt
                                        schnell, sauber und ohne viel Lärm durch den Installateur. Das WC kann nach wenigen
                                            Stunden wieder genutzt werden.</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="shadowbox-white shadow-border-black-top">
                        <div>
                          <div className="row">
                            <div className="col-md-12">
                              <h2>hochglanz Spanndecke</h2>
                              <p>Mit einer hochglanz Spanndecke können Sie in Ihrem Bad einen ganz besonderen
                                            Akzent setzen. Integrierte LED- Strahler, oder ein umlaufendes Lichtband
                                            lassen Ihr Bad erstrahlen. Wir arbeiten hier mit einem kompetenten Raumaustatter
                                                zusammen und beraten Sie dazu gerne.</p>
                            </div>
                          </div>                          
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="shadowbox-gray shadow-border-top">
                        <div className="row">
                          <div className="col-md-12">
                            <h2>Unterputzmodule Emco</h2>
                            <div>Nutzen Sie zusätzlichen Stauraum in Vorwandinstallationen oder im Mauerwerk. Mit
                                        den Modulen von emcoasis ist das ganz einfach. Der dazugehörige Einbaurahmen
                                        ist zum einen Platzhalter während der Bauphase und ferner Einbauhilfe für die
                                        exakte und saubere Montage des Moduls in der Wand. Die Module gibt es passend
                                        zu den Waschtischen der Serie in schwarz und optiwhite sowie zu den ebenfalls
                                        in die Wand integrierbaren Spiegelschränken. Zwei Breiten - 150 und 300 mm -
                                        sowie 5 Höhen stehen zur Auswahl. WC- und Schrankmodul gibt es auch in einer
                                        Aufputzversion. Alle Türen und Klappen lassen sich über die praktische Push-to-open
                                        Funktion öffnen und schliessen. So sind von außen keine Griffe notwendig und
                                            vor allem nicht sichtbar.</div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <br></br>
                            <div id="unterputzmodule-gallery" className="gallery" style={{ display: 'none' }}>
                              <img src="/files/ihr-bad/highlights/emco/thumbnail/01.jpg" data-image="/files/ihr-bad/highlights/emco/01.jpg" />
                              <img src="/files/ihr-bad/highlights/emco/thumbnail/02.jpg" data-image="/files/ihr-bad/highlights/emco/02.jpg" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </respond-html>
            </div>
          </div>
          <div id="Freihandskizze" className="block row" data-nested="not-nested" data-containerid="" data-containercssclass="">
            <div className="col col-md-12">
              <respond-html id="freihandskizzen" description="HTML">
                <a name="freihandskizze"></a>
                <div className="section bg-light-gray">
                  <div className="row">
                    <div className="col-md-4">
                      <h2>Freihandskizze</h2>
                      <p>Bei der Planung Ihres Bades legen wir Wert auf höchste Qualität. Wir setzen uns genau mit Ihrem
                          Raum und Ihren Wünschen auseinander. Dabei ist eine ganzheitliche Planung mit Blick auf die
                          Atmosphäre und Struktur Ihres Raumes genauso wichtig, wie Ihre persönlichen Bedürfnisse und
                          Ihre Wünsche. Wir planen Ihr Bad nicht einfach 3D am Computer, unpersönlich und kühl. Wir
                          zeichnen Ihr Traumbad frei Hand. Anhand einer colorierten Freihandskizze können wir Sie schon
                                vorab in Ihr neues Bad eintauchen lassen.</p>
                    </div>
                    <div className="col-md-8">
                      <br></br>
                      <div id="freihandskizze-gallery" className="gallery" style={{ display: 'none' }}>
                        <img src="/files/ihr-bad/freihand/thumbnail/01.jpg" data-image="/files/ihr-bad/freihand/01.jpg" />
                        <img src="/files/ihr-bad/freihand/thumbnail/02.jpg" data-image="/files/ihr-bad/freihand/02.jpg" />
                        <img src="/files/ihr-bad/freihand/thumbnail/03.jpg" data-image="/files/ihr-bad/freihand/03.jpg" />
                        <img src="/files/ihr-bad/freihand/thumbnail/04.jpg" data-image="/files/ihr-bad/freihand/04.jpg" />
                        <img src="/files/ihr-bad/freihand/thumbnail/05.jpg" data-image="/files/ihr-bad/freihand/05.jpg" />
                        <img src="/files/ihr-bad/freihand/thumbnail/06.jpg" data-image="/files/ihr-bad/freihand/06.jpg" />
                        <img src="/files/ihr-bad/freihand/thumbnail/07.jpg" data-image="/files/ihr-bad/freihand/07.jpg" />
                        <img src="/files/ihr-bad/freihand/thumbnail/08.jpg" data-image="/files/ihr-bad/freihand/08.jpg" />
                        <img src="/files/ihr-bad/freihand/thumbnail/09.jpg" data-image="/files/ihr-bad/freihand/09.jpg" />
                        <img src="/files/ihr-bad/freihand/thumbnail/10.jpg" data-image="/files/ihr-bad/freihand/10.jpg" />
                        <img src="/files/ihr-bad/freihand/thumbnail/11.jpg" data-image="/files/ihr-bad/freihand/11.jpg" />
                      </div>
                    </div>
                  </div>
                </div>
              </respond-html>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/ihr-bad/IhrBad.js